import script from "./ProvenuesBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvenuesBanner.vue?vue&type=script&setup=true&lang=js"

import "./ProvenuesBanner.vue?vue&type=style&index=0&id=5f5305c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5305c1"]])

export default __exports__